module.exports = __webpack_public_path__ + "static/media/placeholder.dca2d734.webp";